/**
 * Instant cart – show/hide Firmhouse checkout buttons by market and subscription.
 */
(function () {
  const MARKET_NL = '93315301640';
  const MARKET_BE = '99640443144';
  const SEPA_MARKET_IDS = new Set([MARKET_NL, MARKET_BE]);

  const MODE_SINGLE_TEXT = 'single-text';
  const MODE_DUAL_SEPA = 'dual-sepa';
  const MODE_CLASSES = [MODE_SINGLE_TEXT, MODE_DUAL_SEPA];

  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  let updateTimer;

  function getMarketId() {
    return document.body.getAttribute('data-market-id') || '';
  }

  function resolveMode(marketId, hasSubscription) {
    if (SEPA_MARKET_IDS.has(marketId) && hasSubscription) {
      return MODE_DUAL_SEPA;
    }
    return MODE_SINGLE_TEXT;
  }

  async function cartHasSubscription() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return false;
      const cart = await res.json();
      return cart.items.some(
        (item) => item.selling_plan_allocation != null
      );
    } catch {
      return false;
    }
  }

  function applyMode(root, mode) {
    if (!root) return;
    root.classList.remove(
      ...MODE_CLASSES.map((m) => `instant-checkout-buttons--${m}`)
    );
    root.classList.add(`instant-checkout-buttons--${mode}`);
  }

  function applyCheckoutCountryHrefs(root) {
    if (!root || !window.bzCheckoutPrefill) return;
    const href = window.bzCheckoutPrefill.addCountryToUrl(window.bzCheckoutPrefill.checkoutRoot());
    root.querySelectorAll('a.regular-checkout, a.ideal-checkout').forEach(function (anchor) {
      anchor.setAttribute('href', href);
    });
  }

  async function updateCheckoutButtons() {
    const root = document.querySelector('.instant-checkout-buttons');
    if (!root) return;

    const marketId = getMarketId();
    const hasSubscription = await cartHasSubscription();
    applyMode(root, resolveMode(marketId, hasSubscription));
    applyCheckoutCountryHrefs(root);
  }

  function scheduleUpdate() {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(updateCheckoutButtons, 100);
  }

  function bindCartSync() {
    if (window.__instantCartCheckoutSyncInstalled) return;
    window.__instantCartCheckoutSyncInstalled = true;

    if (window.fetch) {
      const originalFetch = window.fetch.bind(window);
      window.fetch = async (...args) => {
        const req = args[0];
        const url = typeof req === 'string' ? req : req?.url;
        const res = await originalFetch(...args);
        if (url && CART_RE.test(url)) scheduleUpdate();
        return res;
      };
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (
            node.matches?.('.instant-checkout-buttons') ||
            node.querySelector?.('.instant-checkout-buttons')
          ) {
            scheduleUpdate();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function bindFirmhouseCheckoutClicks() {
    if (window.__instantCartCheckoutClicksInstalled) return;
    window.__instantCartCheckoutClicksInstalled = true;

    document.addEventListener(
      'click',
      (event) => {
        const regular = event.target.closest('a.regular-checkout');
        if (regular) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (typeof window.bzCheckoutPrefill?.goRegularCheckout === 'function') {
            window.bzCheckoutPrefill.goRegularCheckout(event);
            return;
          }
          if (window.bzCheckoutPrefill) {
            window.location.href = window.bzCheckoutPrefill.addCountryToUrl(
              window.bzCheckoutPrefill.checkoutRoot()
            );
          }
          return;
        }

        const ideal = event.target.closest('a.ideal-checkout');
        if (!ideal) return;

        const root = ideal.closest('.instant-checkout-buttons');
        if (!root?.classList.contains(`instant-checkout-buttons--${MODE_DUAL_SEPA}`)) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        window.firmhouse?.sepaCheckout?.(event);
      },
      true
    );
  }

  function init() {
    bindCartSync();
    bindFirmhouseCheckoutClicks();
    scheduleUpdate();

    if (window.firmhouse?.initialized) {
      scheduleUpdate();
    } else {
      window.addEventListener('firmhouse.extensionInitialized', scheduleUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
